/**
 * channelsRailWrapperContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ChannelsRailWrapperContainer = styled.div<{
  displayFilter: boolean;
  displayRail: boolean;
}>`
  display: ${({ displayFilter, displayRail }) =>
    displayFilter || displayRail ? 'flex' : 'none'};
  margin-bottom: ${20 * Screen.widthRatio}px;
`;

export default ChannelsRailWrapperContainer;
